import { CommonErrorCode, TagErrorCode, ViewErrorCode } from '~commonInfra/utils/ErrorCodes';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { IErrorDetail } from '~src/commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~src/commonInfra/contentActions/MultipleItemResult';
import { L10n } from '~src/commonInfra/L10n/L10n';

import { IViewInfo } from '../models/IViewInfo';


export namespace ViewErrors {

  export function errorDetailsFor(viewErrorItem: IErrorItem<IViewInfo>): IErrorDetail {
    return {
      itemName: viewErrorItem.item.name,
      itemUrl: null,
      errorMessage: this.errorMessageFor(viewErrorItem)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IViewInfo>) {
    const view = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.ViewNotFound:
        return Messages.errorViewNotFound({ VIEW_NAME: L10n.elideIfLong(view.name) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorViewInsufficientPermissions();
      case ViewErrorCode.ViewNameAlreadyExists:
        return Messages.errorViewNameAlreadyExists();
      case TagErrorCode.TooManyTags:
        return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});

      default:
        return Messages.errorUnknown();
    }
  }

}
